import { ActionTypes } from 'redux/utils/Value'

export default ActionTypes('INCIDENT_REPORT_COUNT')